<template>
  <div class="home" v-loading.fullscreen.lock="loading">
    <div class="swiper">
      <img class="swiper-img" :src="backgroundImg" alt="">
      <el-carousel :interval="3000" arrow="always">
        <el-carousel-item v-for="(item, index) in swiperImg" :key="index">
          <a :href="item.bannerUrl" v-if='(item.bannerUrl != "http://int.ehsy.com") && (item.bannerUrl != "https://int.ehsy.com")'>
          <img class="swiper-img" :src="item.bannerImg" alt="">
          </a>
          <img class="swiper-img" :src="item.bannerImg" alt="" v-else>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--电脑端适配-->
    <div class="product" v-if='isPhone == null'>
      <div class="product-list">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">{{$t("home.RespiratoryProtection")}}</span>
          <span class='line'></span>
        </div>
        <!--<div class="list-intro">Help prevent the spread of Coronavirus by maintaining at least 2m（6ft）between you and others.</div>-->
        <div class="product-ul">
          <div class="list-classify">· {{$t("home.DisposableProtectiveMask")}}</div>
          <div class="list-box" >
            <div class="product-li" @click='link("CWJ813")'>
                <img class='product-img' src="@/assets/images/home/kouzhao3.png" alt="">
                <p class='product-name'>RX1910  － Classic</p>
            </div>
            <div class="product-li" @click='link("CWJ815")'>
              <img class='product-img' src="@/assets/images/home/kouzhao4.png" alt="">
              <p class='product-name'> RX1810 － Unibody forming</p>
            </div>
            <div class="product-li" @click='link("CWJ812")'>
              <img class='product-img' src="@/assets/images/home/kouzhao5.png" alt="">
              <p class='product-name'>RX2010  －  Japanese style</p>
            </div>
            <div class="product-li" @click='link("CWJ811")'>
              <img class='product-img' src="@/assets/images/home/kouzhao6.png" alt="">
              <p class='product-name'>RX2010K  － Japanese style (For kids)</p>
            </div>
          </div>
        </div>

        <div class="product-ul">
          <div class="list-classify">· KN95 Particulate Respirator</div>
          <div class="list-box list-box4">
            <div class="product-li" @click='link("CWJ807")'>
              <img class='product-img' src="@/assets/images/home/kouzhao7.png" alt="">
              <p class='product-name'> RX9501  －  Earloop</p>
            </div>
            <div class="product-li" @click='link("CWJ808")'>
              <img class='product-img' src="@/assets/images/home/kouzhao8.png" alt="">
              <p class='product-name'> RX9511  －  Earloop</p>
            </div>
            <div class="product-li" @click='link("CWJ810")'>
              <img class='product-img' src="@/assets/images/home/kouzhao9.png" alt="">
              <p class='product-name'> RX9501K  － Earloop (For kids)</p>
            </div>
            <div class="product-li" @click='link("CWJ809")'>
              <img class='product-img' src="@/assets/images/home/kouzhao10.png" alt="">
              <p class='product-name'> RX9501P  － Headband</p>
            </div>
          </div>
        </div>

      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>

      <div class="product-list fanghu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Protective Appliances</span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box3">
            <div class="product-li" @click='link("BEN465")'>
              <img class='product-img' src="@/assets/images/home/fanghu11.png" alt="">
              <p class='product-name'>Disposable nitrile examination gloves</p>
            </div>
            <div class="product-li" @click='link("CXH416")'>
              <img class='product-img' src="@/assets/images/home/fanghu14.png" alt="">
              <p class='product-name'>Disposable nitrile examination gloves</p>
            </div>
            <div class="product-li" @click='link("CVE155")'>
              <img class='product-img' src="@/assets/images/home/fanghu12.png" alt="">
              <p class='product-name'>Disposable isolation clothing</p>
            </div>
            <div class="product-li" @click='link("CUX670")'>
              <img class='product-img' src="@/assets/images/home/fanghu13.png" alt="">
              <p class='product-name'>Disposable medical protective clothing</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>
      <div class="product-list xiaodu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Disinfection Supplies</span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box5">
            <div class="product-li" @click='link("CRV048")'>
              <img class='product-img' src="@/assets/images/home/xiaodu14.png" alt="">
              <p class='product-name'>Advanced hand sanitizer</p>
            </div>
            <div class="product-li" @click='link("CVK318")'>
              <img class='product-img' src="@/assets/images/home/xiaodu15.png" alt="">
              <p class='product-name'>Hand sanitizer（500ml）</p>
            </div>
            <div class="product-li" @click='link("CVK317")'>
              <img class='product-img' src="@/assets/images/home/xiaodu16.png" alt="">
              <p class='product-name'> Hand sanitizer（500ml）</p>
            </div>
            <div class="product-li" @click='link("CVK319")'>
              <img class='product-img' src="@/assets/images/home/xiaodu17.png" alt="">
              <p class='product-name'>Hand sanitizer（60ml）</p>
            </div>
            <div class="product-li" @click='link("CWJ907")'>
              <img class='product-img' src="@/assets/images/home/xiaodu18.png" alt="">
              <p class='product-name'>Misept alcohol wipes</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>
      <div class="product-list xiaodu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Temperature Monitoring </span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box5">
            <div class="product-li" @click='link("CWH440")'>
              <img class='product-img' src="@/assets/images/home/cewen19.png" alt="">
              <p class='product-name'>Infrared thermometer（UT300）</p>
            </div>
            <div class="product-li" @click='link("CWH441")'>
              <img class='product-img' src="@/assets/images/home/cewen21.png" alt="">
              <p class='product-name'>Infrared thermometer（UT305）</p>
            </div>
            <div class="product-li" @click='link("CWH442")'>
              <img class='product-img' src="@/assets/images/home/cewen20.png" alt="">
              <p class='product-name'>Infrared thermometer（FR850）</p>
            </div>
            <div class="product-li" @click='link("CWH443")'>
              <img class='product-img' src="@/assets/images/home/cewen22.png" alt="">
              <p class='product-name'> Infrared thermometer（AET-R1B1）</p>
            </div>
            <div class="product-li" @click='link("CWH446")'>
              <img class='product-img' src="@/assets/images/home/cewen23.png" alt="">
              <p class='product-name'>Infrared thermal imager（226B）</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>


    </div>

    <!--手机端-->
    <div class="product isPhone" v-if='isPhone != null'>
      <div class="product-list">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Respiratory Protection </span>
          <span class='line'></span>
        </div>
        <!--<div class="list-intro">Help prevent the spread of Coronavirus by maintaining at least 2m（6ft）between you and others.</div>-->
        <div class="product-ul">
          <div class="list-classify">· Disposable Protective Mask</div>
          <div class="list-box" >
            <div class="product-li" @click='link("CWJ813")'>
              <img class='product-img' src="@/assets/images/home/kouzhao3.png" alt="">
              <p class='product-name'>RX1910  － Classic</p>
            </div>
            <div class="product-li" @click='link("CWJ815")'>
              <img class='product-img' src="@/assets/images/home/kouzhao4.png" alt="">
              <p class='product-name'> RX1810 － Unibody forming</p>
            </div>
            <div class="product-li" @click='link("CWJ812")'>
              <img class='product-img' src="@/assets/images/home/kouzhao5.png" alt="">
              <p class='product-name'>RX2010  －  Japanese style</p>
            </div>
            <div class="product-li" @click='link("CWJ811")'>
              <img class='product-img' src="@/assets/images/home/kouzhao6.png" alt="">
              <p class='product-name'>RX2010K  － Japanese style (For kids)</p>
            </div>
          </div>
        </div>

        <div class="product-ul">
          <div class="list-classify">· KN95 Particulate Respirator</div>
          <div class="list-box list-box4">
            <div class="product-li" @click='link("CWJ807")'>
              <img class='product-img' src="@/assets/images/home/kouzhao7.png" alt="">
              <p class='product-name'> RX9501  －  Earloop</p>
            </div>
            <div class="product-li" @click='link("CWJ808")'>
              <img class='product-img' src="@/assets/images/home/kouzhao8.png" alt="">
              <p class='product-name'> RX9511  －  Earloop</p>
            </div>
            <div class="product-li" @click='link("CWJ810")'>
              <img class='product-img' src="@/assets/images/home/kouzhao9.png" alt="">
              <p class='product-name'> RX9501K  － Earloop (For kids)</p>
            </div>
            <div class="product-li" @click='link("CWJ809")'>
              <img class='product-img' src="@/assets/images/home/kouzhao10.png" alt="">
              <p class='product-name'> RX9501P  － Headband</p>
            </div>
          </div>
        </div>

      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>

      <div class="product-list fanghu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Protective Appliances</span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box3">
            <div class="product-li" @click='link("BEN465")'>
              <img class='product-img' src="@/assets/images/home/fanghu11.png" alt="">
              <p class='product-name'>Disposable nitrile examination gloves</p>
            </div>
            <div class="product-li" @click='link("CXH416")'>
              <img class='product-img' src="@/assets/images/home/fanghu14.png" alt="">
              <p class='product-name'>Disposable nitrile examination gloves</p>
            </div>
            <div class="product-li" @click='link("CVE155")'>
              <img class='product-img' src="@/assets/images/home/fanghu12.png" alt="">
              <p class='product-name'>Disposable isolation clothing</p>
            </div>
            <div class="product-li" @click='link("CUX670")'>
              <img class='product-img' src="@/assets/images/home/fanghu13.png" alt="">
              <p class='product-name'>Disposable medical protective clothing</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>
      <div class="product-list xiaodu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Disinfection Supplies</span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box5">
            <div class="product-li" @click='link("CRV048")'>
              <img class='product-img' src="@/assets/images/home/xiaodu14.png" alt="">
              <p class='product-name'>Advanced hand sanitizer</p>
            </div>
            <div class="product-li" @click='link("CVK318")'>
              <img class='product-img' src="@/assets/images/home/xiaodu15.png" alt="">
              <p class='product-name'>Hand sanitizer（500ml）</p>
            </div>
            <div class="product-li" @click='link("CVK317")'>
              <img class='product-img' src="@/assets/images/home/xiaodu16.png" alt="">
              <p class='product-name'> Hand sanitizer（500ml）</p>
            </div>
            <div class="product-li" @click='link("CVK319")'>
              <img class='product-img' src="@/assets/images/home/xiaodu17.png" alt="">
              <p class='product-name'>Hand sanitizer（60ml）</p>
            </div>
            <div class="product-li" @click='link("CWJ907")'>
              <img class='product-img' src="@/assets/images/home/xiaodu18.png" alt="">
              <p class='product-name'>Misept alcohol wipes</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>
      <div class="product-list xiaodu">
        <div class="list-title">
          <span class='line'></span>
          <span class="big-classify">Temperature Monitoring </span>
          <span class='line'></span>
        </div>
        <div class="product-ul">
          <div class="list-box list-box5">
            <div class="product-li" @click='link("CWH440")'>
              <img class='product-img' src="@/assets/images/home/cewen19.png" alt="">
              <p class='product-name'>Infrared thermometer（UT300）</p>
            </div>
            <div class="product-li" @click='link("CWH441")'>
              <img class='product-img' src="@/assets/images/home/cewen21.png" alt="">
              <p class='product-name'>Infrared thermometer（UT305）</p>
            </div>
            <div class="product-li" @click='link("CWH442")'>
              <img class='product-img' src="@/assets/images/home/cewen20.png" alt="">
              <p class='product-name'>Infrared thermometer（FR850）</p>
            </div>
            <div class="product-li" @click='link("CWH443")'>
              <img class='product-img' src="@/assets/images/home/cewen22.png" alt="">
              <p class='product-name'> Infrared thermometer（AET-R1B1）</p>
            </div>
            <div class="product-li" @click='link("CWH446")'>
              <img class='product-img' src="@/assets/images/home/cewen23.png" alt="">
              <p class='product-name'>Infrared thermal imager（226B）</p>
            </div>
          </div>
        </div>
      </div>

      <div class="contact">
        <router-link to="/Contact">
          <span class="contact-text">Contact</span>
        </router-link>
      </div>

    </div>


    <div class="intro">
      <div class="intro-title">
        <div class="line"></div>
        <div class="title-content-border">
          <div class="title-content-box">
            <p class="title-content">Headquarters,</p>
            <p class="title-content"> Shanghai Office of EHSY</p>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <img class='office-img' src="@/assets/images/home/bangongshi24.jpg" alt="">
    </div>

    <div class="intro">
      <div class="intro-title">
        <div class="line"></div>
        <div class="title-content-border">
          <div class="title-content-box">
            <p class="title-content">Corporate Milestones</p>
            <!--<p class="title-content">aeqrqrqwerqqerqerqed</p>-->
          </div>
        </div>
        <div class="line"></div>
      </div>
      <div class="time">
        <div class="time-classify">
          <div class="time-detail time2002">
            <div class="time-event">
              <p>Registered and established in Shanghai, China</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2002</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2009">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2009</div>
            </div>
            <div class="time-event">
              <p> Develop domestic MRO industrial commodity market</p>
            </div>


          </div>
          <div class="time-detail time2011">
            <div class="time-event">
              <p>Acquired Angel financing and Completed “A” Round
                financing from FORTUNE CAPITAL</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2011</div>
              <div class="circle"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="time last-time">
        <div class="time-classify time-classify2">
          <div class="time-detail time2012">
            <div class="time-event">
              <p>30,000m2 Asia Pacific Logistic
                Center launched in Zhejiang.</p>
            </div>

            <div class="circle-time">
              <div class="detail-time">2012</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2015-1">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2015</div>
            </div>
            <div class="time-event">
              <p>"B" Round financing from IDG; professional MRO online retailer in China</p>
            </div>
          </div>
          <div class="time-detail time2015-2">
            <div class="time-event">
              <p>"C" Round financing from China-Belgium Fund ,ChinaLink, Fortune Link and JWVENTURES.</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2015</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2017-1">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2017</div>
            </div>
            <div class="time-event">
              <p>Completed "D" Round financing from CICC ALPHA</p>
            </div>
          </div>
          <div class="time-detail time2017-2">
            <div class="time-event">
              <p> E-commerce Demonstration
                Enterprise from China Ministry of Commerce</p>
            </div>
            <div class="circle-time">
              <div class="detail-time">2017</div>
              <div class="circle"></div>
            </div>
          </div>
          <div class="time-detail time2020">
            <div class="circle-time">
              <div class="circle"></div>
              <div class="detail-time">2020</div>
            </div>
            <div class="time-event">
              <p> Implement new strategy, a global professional MRO online retailer</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer-content></footer-content>
  </div>
</template>

<script>
  import footerContent from '@/components/footer.vue';
  // import img1 from '@/assets/images/home/headImage1.jpg'
  // import img2 from '@/assets/images/home/headImage2.jpg'
  // import img3 from '@/assets/images/home/headImage3.jpg'
  export default {
    name: "home",
    components: {
      footerContent
    },
    data () {
      return{
        swiperImg: [],
        isPhone: null,
        backgroundImg:'',
        loading:false,
      }
    },
    created(){
      // 添加判断方法
     this.isMobile();
     this.getBanner()
    },
    methods: {
      link: function(sku){
        this.$router.push({path:'/productDetail',query: {skuCode:sku}})
      },
      getBanner: function (){
        let _this = this;
        _this.loading = true;
        let params = {
          terminalType: 'int_home_banner'
        }
        this.$http.get('pb/homepage/carousel/figures?terminalType=int_home_banner', params).then(res => {
          _this.loading = false;
          if(res.body.mark == 0){
            _this.swiperImg = res.body.data;
            _this.backgroundImg =  _this.swiperImg[0].bannerImg;
          }else{
          }
        });
      },
      // 添加判断方法
      isMobile() {
        this.isPhone = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      }
    }
  }
</script>

<style scoped>

  /deep/ .el-carousel{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  /deep/ .el-carousel__container{
    height: 100%;
    width: 100%;
  }

  /deep/ .el-carousel__arrow{
    width: 4rem;
    height: 4rem;
    font-size: 2.5rem;
  }
  .swiper{
    width:100%;
    position: relative;
  }
  .swiper .swiper-img{
    display: block;
    width: 100%;
  }
  .product{
    padding:60px 60px 0;
  }
  .product .product-list{
    width:100%;
    margin-top: 60px;
  }
  .product .product-list .list-title {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product .product-list .list-title .line{
    width: 150px;
    height: 1px;
    background: #b7b7b7;
  }
  .product .product-list .list-title .big-classify{
    font-size: 1.6rem;
    margin: 0 20px;
    font-weight: bold;
  }
  .product .product-list .list-intro{
    font-size: 1.1rem;
    color: #777777;
    margin: 30px 0 60px;
    text-align: center;
  }

  .product .product-list .product-ul{
    width: 100%;
    margin-top: 60px;
  }
  .product .product-list .product-ul .list-classify{
    color: #2d69a2;
    font-size: 18px;
    text-align: center;
    margin-bottom: 30px;
  }
  .product .product-list .product-ul .list-box{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /*justify-content: space-around;*/
  }
  .product-list .product-ul .product-li{
    width:18%;
    margin:0 8px;
  }
  .product-list .product-ul .product-li:hover{
    cursor:pointer
  }
  .product-list .product-ul .product-li .product-img{
    width:100%;
  }
  .product-list .product-ul .product-li .product-name{
    font-size: 13px;
    color: #666666;
    text-align: center;
    margin-top:10px;
  }


  .product .contact{
    text-align: center;
    margin: 70px 0 100px;
  }
  .contact-text{
    padding: 5px 20px;
    font-size: 20px;
    border-radius: 5px;
    background: #000;
    color: #fff;
  }
  .product-list.fanghu .product-ul .product-li{
    /*width:18%;*/
    /*margin:0 30px;*/
  }
  .product-list.xiaodu .product-ul .product-li{
    width:18%;
    margin:0 1%;
  }


  /*手机端样式*/
  .product.isPhone{
    padding:60px 100px 0;
  }
  .product.isPhone .contact .contact-text{
    display: inline-block;
    margin: 10px 25px;
    font-size: 35px;
  }
  .product.isPhone .product-list .list-intro{
   font-size: 27px;
  }
  .product.isPhone .product-list .product-ul .list-box {
    justify-content: space-between;
  }
  .product.isPhone .product-list .product-ul .list-classify {
    font-size: 1.1rem;
  }
  .product.isPhone .product-list .product-ul .product-li {
    width: 46%;
    margin: 0 0 50px 0;
  }
  .product.isPhone .product-list .product-ul .product-li .product-name{
    font-size: 25px;
    color: #666666;
    text-align: center;
    margin-top: 15px;
  }
  .intro{
    margin-top: 146px;
  }
  .intro .intro-title{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .intro .intro-title .line{
    width: 120px;
    height: 1px;
    background: #b7b7b7;
  }

  .intro .intro-title .title-content-border{
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin: 0 50px;
    border: 1px solid #b7b7b7;
    position: relative;
  }
  .intro .intro-title .title-content-box{
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .intro .intro-title .title-content-box .title-content{
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    text-align: center;
  }
  .intro .office-img{
    display: block;
    width: 90%;
    margin: 80px auto;
    border-radius: 15px;
  }

  .intro .time{
    width: 100%;
  }
  .intro .time .time-classify{
    width: 100%;
    height: 1px;
    background: #b7b7b7;
    margin-top: 200px;
    position: relative;
  }
  .intro .time .time-classify .time-detail{
    position: absolute;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 30%;
    height: 120px;
  }
  /*奇数行*/
  .intro .time .time-classify .time-detail:nth-child(odd){
    bottom: -6px;
  }

  /*偶数行*/
  .intro .time .time-classify .time-detail:nth-child(even){
    top: -6px;
  }
  .time .time-classify .time-detail .circle-time{
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .time .time-classify .time-detail .circle{
    width:12px;
    height: 12px;
    border-radius: 50%;
    background: #000;
  }
  .time .time-classify .time-detail .time-event{
    width: 100%;
    font-size: 14px;
    overflow-wrap: break-word;
    text-align: center;
    color: #767676;
  }
  .detail-time{
    font-weight: bold;
    font-size: 13px;
  }
  .intro .time .time-classify.time-classify2 .time-detail{
    width: 20%;
  }

  .intro .time .time-classify .time-detail.time2002{
    left:22%;
  }

  .intro .time .time-classify .time-detail.time2009{
    left: 50%;
  }

  .intro .time .time-classify .time-detail.time2011{
    left: 78%;
  }
  .intro .time.last-time{
    margin: 330px 0 230px;
  }
  .intro .time .time-classify .time-detail.time2012{
    left: 16%;
  }

  .intro .time .time-classify .time-detail.time2015-1{
    left: 29.6%;
  }

  .intro .time .time-classify .time-detail.time2015-2{
    left: 43.2%;
  }

  .intro .time .time-classify .time-detail.time2017-1{
    left: 56.8%;
  }

  .intro .time .time-classify .time-detail.time2017-2{
    left: 70.4%;
  }

  .intro .time .time-classify .time-detail.time2020{
    left: 84%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue